export const REQUESTED = 'SA_PROFILE_VIEW_REQUESTED';
export const FAILED = 'SA_PROFILE_VIEW_FAILED';
export const SUCCESSFUL = 'SA_PROFILE_VIEW_SUCCESSFUL';
export const ADD_VIDEO_REQUESTED = 'ADD_VIDEO_REQUESTED';
export const ADD_VIDEO_FAILED = 'ADD_VIDEO_FAILED';
export const ADD_VIDEO_SUCCESSFUL = 'ADD_VIDEO_SUCCESSFUL';
export const SAVE_VIDEO_DETAILS = 'SAVE_VIDEO_DETAILS';
export const SAVE_USER_IMAGE = 'SAVE_USER_IMAGE';
export const SET_CURRENT_VIDEO = 'SET_CURRENT_VIDEO';
export const GET_TOTAL_COUNTS_SUCCESSFUL_PROFILE = 'GET_TOTAL_COUNTS_SUCCESSFUL_PROFILE';
export const GET_TOTAL_COUNTS_FAILED_PROFILE = 'GET_TOTAL_COUNTS_FAILED_PROFILE';
export const GET_TOTAL_COUNTS_REQUESTED_PROFILE = 'GET_TOTAL_COUNTS_REQUESTED_PROFILE';
export const REMOVE_VIDEO_REQUESTED = 'REMOVE_VIDEO_REQUESTED';
export const REMOVE_VIDEO_FAILED = 'REMOVE_VIDEO_FAILED';
export const REMOVE_VIDEO_SUCCESSFUL = 'REMOVE_VIDEO_SUCCESSFUL';
export const INCREASE_CONTACT_COUNT = 'INCREASE_CONTACT_COUNT';



// WEBPACK FOOTER //
// ./src/containers/Profile-view/actionTypes.js